module.exports = __webpack_public_path__ + "static/media/furnizori-card.621b6140.svg";